module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point2_4-5ae451c6eccb3afa1a26876160327882.jpg";